export const pkg = {
  name: 'isomorphic-git',
  version: '1.32.0',
  agent: 'git/isomorphic-git@1.32.0',
}
